export default "<div class=\"card-body\">\n    <ng-content></ng-content>\n</div>\n";